import React from 'react';
import PropTypes from 'prop-types';

const Message = props => {
  const { isSuccess, message } = props;
  const messageClass = isSuccess ? 'is-info' : 'is-warning';

  return <div className={`notice ${messageClass}`}>{message}</div>;
};

Message.propTypes = {
  isSuccess: PropTypes.bool,
  message: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
};

Message.defaultProps = {
  isSuccess: true,
};

export default Message;



// WEBPACK FOOTER //
// ./src/components/Message.js